module.exports = __webpack_public_path__ + "img/landingpage.50f99db7.png";